import { IListResult } from '@core/interfaces/list-result/list-result.interface';

export class ListResult<T, K> {

  readonly resultsLength: number;
  readonly results: K[];

  constructor(
    iListResult: IListResult<T>,
    ListItem: (new (iListItem: T) => K)
  ) {
    this.resultsLength = iListResult.resultsLength;
    this.results = Array.isArray(iListResult.results) ? iListResult.results.map((iListItem: T) => new ListItem(iListItem)) : [];
  }

}
